import { render, staticRenderFns } from "./cancelRealName.vue?vue&type=template&id=8168df82&"
import script from "./cancelRealName.vue?vue&type=script&lang=js&"
export * from "./cancelRealName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports